import React, {useEffect, useState} from 'react';
import classnames from 'classnames';
import {useSelector} from 'react-redux';
import authDao from '../../../dao/authDao';
import Avatar from '../../accountsetting/Avatar';
import Loader from '../../spinner/Loader';
import _isEmpty from 'lodash/isEmpty';
import {useDebounce} from 'use-debounce';

export default function({isPartner}) {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const [show, setShow] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [param] = useDebounce(search, 1000);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (!_isEmpty(param)) {
      setLoad(true);
      Promise.all([
        authDao
          .listAllCustomers({customerType: 'SMB', param: param})
          .then(r => {
            return r.results;
          }),
        authDao
          .listAllCustomers({customerType: 'SHOPIFY', param: param})
          .then(r => {
            return r.results;
          }),
      ]).then(r => {
        setCustomers(r[0].concat(r[1]));
        setLoad(false);
      });
    } else {
      setCustomers([]);
    }
  }, [param]);

  function doSwitch(customerId) {
    if (!customerId) {
      return;
    }
    authDao.switchCustomer(customerId).then(r => {
      if (r && r.status && r.status === 'success') {
        window.location.href = isPartner ? '/partner' : '/';
      }
    });
  }

  return (
    <div className="kt-header__topbar-item" style={{position: 'relative'}}>
      <div
        className="kt-header__topbar-wrapper pf-header-user-wrapper"
        style={{width: isPartner ? '150px' : ''}}
        onClick={() => setShow(!show)}
      >
        <div className="pf-header-user-info">
          <Avatar
            imageUrl={auth.account.imageUrl}
            width={isPartner ? '150' : '40'}
            height={isPartner ? '150' : '40'}
          />
          <span className="pf-header-text kt-visible-desktop pl-2">
            {`${auth.account.firstName} ${auth.account.lastName}`}
          </span>{' '}
        </div>
      </div>
      <div
        className={classnames({
          'dropdown-menu': true,
          'dropdown-menu-fit': true,
          'dropdown-menu-right': true,
          'dropdown-menu-anim': true,
          'dropdown-menu-top-unround': true,
          'dropdown-menu-xl': true,
          show: show,
        })}
        style={{
          left: '-10vh',
          width: 'min-content',
          maxHeight: '25vh',
          borderRadius: '4px',
          overflow: 'hidden scroll',
        }}
      >
        <div
          className={classnames({
            'kt-user-card': true,
            'kt-user-card--skin-dark': true,
            'kt-notification-item-padding-x': true,
          })}
          style={{padding: 0, margin: '0 -8px'}}
        >
          <div className="kt-notification">
            <div className="input-group-sm" style={{padding: '10px 3px'}}>
              <input
                value={search}
                type="text"
                className="form-control"
                placeholder={'Start type to find customers...'}
                onChange={e => setSearch(e.target.value)}
                style={{width: '220px'}}
              />
            </div>
            {load ? (
              <div className="d-flex justify-content-center kt-margin-20">
                <Loader />
              </div>
            ) : (
              customers.map(c => (
                <a
                  key={'customer_' + c.customerId}
                  className="kt-notification__item"
                  style={{
                    cursor: 'pointer',
                    padding: '5px',
                    width: '230px',
                    backgroundColor: c.isShopify ? '#e5eeda' : '',
                  }}
                  onClick={() => doSwitch(c.customerId)}
                >
                  <div
                    className="kt-notification__item-details"
                    style={{minHeight: '40px'}}
                  >
                    <div
                      className="kt-notification__item-title kt-font-bold"
                      style={{
                        fontSize: '13px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        width: '195px',
                      }}
                    >
                      {c.email}
                    </div>
                    <div
                      className="kt-notification__item-time"
                      style={{
                        fontSize: '13px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        width: '195px',
                      }}
                    >
                      {c.customerName}
                    </div>
                  </div>
                </a>
              ))
            )}
          </div>
        </div>
      </div>
      {show ? (
        <div className="dropdown-menu__popover">
          <div
            className="dropdown-menu__cover"
            onClick={() => setShow(false)}
          />
        </div>
      ) : null}
    </div>
  );
}
